import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dark main-content d-flex flex-column transition overflow-hidden" }

import MainHeader from '../components/MainHeader'
import MainSidebar from '../components/MainSidebar'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

onMounted(() => {
  document.body.classList.toggle('dark', true)
  document.body.classList.add('bg-body-secondary')
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MainHeader)),
    _createVNode(_unref(MainSidebar)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})